<script>
    export let options;

    // Iterate over each object in the array and sort based on numeric value
    options.forEach((obj) => {
        obj.values.sort((a, b) => {
            const numA = parseInt(a);
            const numB = parseInt(b);

            if (!isNaN(numA) && !isNaN(numB)) {
                return numA - numB;
            } else {
                return a.localeCompare(b);
            }
        });
    });


</script>

<table>
    <tbody>
        {#each options as option}
            <tr>
                <td class="w-24"><span class="text-sm text-color-text/80">{option.name}</span></td>
                <td>
                    <span class="">
                        <span>{option.values.join(", ")}</span>
                    </span>
                </td>
            </tr>
        {/each}
    </tbody>
</table>
